// src/pages/CourseTime/components/activities/JournalingActivity.comp.jsx
import React from 'react';
import * as S from '../../styles';
import {FullActivityPill} from "../../styles";
import { GET_APP_LOCALIZE_TEXT } from '../../../../utils/dq_lc_service/lc_service';
import { renderPlainTextWithFormatting } from '../../utils';


const JournalingActivity = ({
  slide,
  journalingText,
  setJournalingText,
  onSave,
  onEditActivity,
  interactionLoading,
  fetchingExistingRecord,
  inputsDisabled,
  activityCompleted,
  themeColor,
  pageLc
}) => {
  const renderHtmlContent = (content) => {
    if (!content) return null;
    const text = String(content).trim();
    const hasHtml = /<[^>]+>/.test(text);
    return hasHtml
      ? <span dangerouslySetInnerHTML={{ __html: text }} />
      : renderPlainTextWithFormatting(text);
  };

  return (
    <S.ActivityWrapper>
      <S.ActivityContainer>
        {/* Left Side */}
        <S.ActivityLeft>
          <S.FullActivityPill>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__journaling_time')}!</S.FullActivityPill>
          <S.ActivityTitle>{renderHtmlContent(slide.SlideTitle)}</S.ActivityTitle>
          <S.ActivityContent>{renderHtmlContent(slide.SlideContent)}</S.ActivityContent>
        </S.ActivityLeft>

        {/* Right Side */}
        <S.ActivityJournalingRight>
          <S.JournalingTextArea
            placeholder={GET_APP_LOCALIZE_TEXT(pageLc, 'ct__journaling_placeholder') + '...'}
            value={journalingText}
            onChange={(e) => setJournalingText(e.target.value)}
            disabled={inputsDisabled}
            themeColor={themeColor}
          />
          <S.SaveButton
            onClick={() => onSave(slide)}
            disabled={!journalingText.trim() || interactionLoading || inputsDisabled}
          >
            {interactionLoading
              ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__saving') + '...'
              : activityCompleted[slide.SlideID]
                ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__saved')
                : GET_APP_LOCALIZE_TEXT(pageLc, 'ct__save')}
          </S.SaveButton>
          
          {/* Response saved indicator */}
          {inputsDisabled && !fetchingExistingRecord && activityCompleted[slide.SlideID] && (
            <S.ResponseSavedWrapper>
              <S.ResponseSavedIndicator>
                  <i className="fa fa-lock" style={{ marginRight: "6px" }} />
                  {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__response_saved')}
              </S.ResponseSavedIndicator>
              <S.EditButton 
                onClick={() => onEditActivity(slide)}
                title="Edit response"
                themeColor={themeColor}
              >
                <i className="fa fa-pencil" />
              </S.EditButton>
            </S.ResponseSavedWrapper>
          )}
        </S.ActivityJournalingRight>
      </S.ActivityContainer>

      {/* Loading overlay */}
      {fetchingExistingRecord && (
        <S.ActivityLoadingOverlay>
          <S.LoadingSpinner />
          <S.LoadingText>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__loading_existing_record')}...</S.LoadingText>
        </S.ActivityLoadingOverlay>
      )}
    </S.ActivityWrapper>
  );
};

export default JournalingActivity;
